export const customTheme = theme => ({
  ...theme,
  borderRadius: "2px",
  boxShadow: "#e8e8e8 0px 0px 0px 1px inset", // durian
  border: "none",
  colors: {
    ...theme.colors,
    primary25: "#F2F2F2", // copoazu
    primary: "#F2F2F2", // copoazu
  },
});

export const customSingleTheme = theme => ({
  ...theme,
  borderRadius: "2px",
  boxShadow: "#e8e8e8 0px 0px 0px 1px inset", // durian
  border: "none",
  colors: {
    ...theme.colors,
    primary25: "#F2F2F2", // copoazu
    primary: "#FFFFFF", // coco
  },
});

export const customStyles = {
  indicatorSeparator: (provide, state) => ({
    ...provide,
    display: "none",
  }),
  menu: (provide, state) => ({
    ...provide,
    cursor: "pointer",
    boxShadow: "0 -2px 7px 0 #03161616, 0 2px 10px 0 #1A505050", // medium
  }),
  dropdownIndicator: (provide, state) => ({
    ...provide,
    fill: "#B0B0B0", // guama
    padding: "12px",
  }),
  control: (provide, state) => ({
    ...provide,
    cursor: "pointer",
    boxShadow: "#e8e8e8 0px 0px 0px 1px inset", // guijarro
    border: "none",
    ":hover": {
      boxShadow: "#848484 0px 0px 0px 1px inset", // guijarro
    },
  }),
  placeholder: (provide, state) => ({
    color: "#848484",
    margin: " 6px 0px",
  }),
  clearIndicator: (provide, state) => ({
    ...provide,
    display: "none",
  }),
  option: (provide, state) => ({
    ...provide,
    cursor: "pointer",
    color: state.isFocused ? "#161616" : "#848484", // sonar or guijarro
  }),
  input: (provide, state) => ({
    ...provide,
    margin: 0,
    padding: 0,
  }),
  multiValue: (provide, state) => ({
    ...provide,
    backgroundColor: "#ffffff", // coco
    color: "#161616", // sonar
    borderRadius: "99em",
    margin: "5px 0",
    padding: "0px 12px",
    marginRight: "8px",
    border: "1px solid #E8E8E8", // durian
  }),
  multiValueLabel: (provide, state) => ({
    ...provide,
    color: "#161616", // sonar
    fontSize: "13px",
    padding: 0,
    paddingLeft: 0,
    paddingRight: "8px",
  }),
  multiValueRemove: (provide, state) => ({
    ...provide,
    color: "#161616", // sonar
    paddingLeft: 0,
    cursor: "pointer",
    paddingRight: 0,
    ":hover": {
      color: "#161616", // sonar
      backgroundColor: "#ffffff", // coco
    },
  }),
  valueContainer: (provide, state) => ({
    ...provide,
    fontSize: "15px",
    lineHeight: "24px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
    "@media screen and (min-width: 36em)": {
      fontSize: "15px",
    },
    "@media screen and (min-width: 62em)": {
      fontSize: "18px",
    },
  }),
};

export const customStylesWithError = {
  ...customStyles,
  control: (provide, state) => ({
    ...provide,
    cursor: "pointer",
    boxShadow: "#F02D00 0px 0px 0px 1px inset", // rambutan
    border: "none",
  }),
};
